export default __webpack_public_path__ + "media/color/plr-21a42ad4.svg";